import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

export default function FoundersCorner() {
    return (
        <section className="border-t border-white/10 px-5 py-24 md:px-10 md:py-32" data-testid="founders-section">
            <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-10">
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="relative lg:col-span-4"
                >
                    <div className="absolute -left-4 -top-4 h-full w-full border border-blaze" />
                    <div className="relative aspect-[4/5] overflow-hidden border border-white/15 bg-panel" data-testid="founder-photo-slot">
                        <img
                            src="/founder.jpg"
                            alt="Ashok Pandey — Founder & Partner, Akash Network"
                            className="h-full w-full object-cover object-top"
                            data-testid="founder-photo"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-void/40 via-transparent to-transparent" />
                    </div>
                    <div className="absolute -bottom-5 -right-3 border border-blaze bg-void px-4 py-3 md:-right-5">
                        <p className="font-display text-xl uppercase leading-none text-blaze" data-testid="founder-name">Ashok Pandey</p>
                        <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-white/50">Founder &amp; Partner</p>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-8 lg:pl-10"
                >
                    <p className="mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-blaze md:text-xs">
                        <span className="inline-block h-2 w-2 bg-blaze" />
                        Founder&rsquo;s Corner
                    </p>
                    <h2 className="mb-10 font-display text-4xl uppercase leading-[0.95] tracking-tight md:text-5xl">
                        Connecting businesses. <span className="text-outline-faint">Delivering trust.</span>
                    </h2>
                    <div className="relative border-l-2 border-blaze pl-8 md:pl-10" data-testid="founder-quote">
                        <Quotes size={30} weight="fill" className="absolute -left-4 -top-3 bg-void p-0.5 text-blaze" />
                        <blockquote className="max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
                            From day one, our goal has been straightforward: to build a transport network grounded in
                            safety, speed, and complete reliability. Through Akash Cargo Movers, Anshika Roadlines, and
                            Akash Logistics India, we treat every shipment as a shared responsibility. Logistics isn&rsquo;t
                            just transit — it&rsquo;s the lifeline that keeps businesses connected and promises fulfilled.
                            Here&rsquo;s to moving forward, forging stronger bonds, and growing together.
                        </blockquote>
                        <footer className="mt-8 flex items-center gap-4">
                            <span className="h-px w-12 bg-blaze" />
                            <p className="text-xs uppercase tracking-[0.25em] text-white/50">
                                Ashok Pandey — Founder &amp; Partner, Akash Network
                            </p>
                        </footer>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
